import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { Box } from '@h2/components/layout/box'
import { Button } from '@h2/components/buttons/button'

const Wrap = styled(Box)`
  width: 100%;
  align-self: ${({ centered }) => (centered ? 'center' : 'normal')};

  &:only-child {
    margin-left: auto;
  }

  @media (${features.minWidth.laptop}) {
    width: 250px;
  }
`
const SubmitBtn = styled(Button)`
  font-size: 20px;
`
const Submit = ({
  form,
  onClick,
  type = 'submit',
  text = 'Submit',
  centered = false,
  isDisabled = false,
  isLoading = false
}) => {
  return (
    <Wrap centered={centered}>
      <SubmitBtn
        isFullWidth
        isFullHeight
        type={type}
        form={form}
        size="large"
        variant="cta"
        align="center"
        onClick={onClick}
        isLoading={isLoading}
        isDisabled={isDisabled}>
        {text}
      </SubmitBtn>
    </Wrap>
  )
}

Submit.propTypes = {
  form: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  centered: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button']),
  text: PropTypes.string
}

export { Submit }
